import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  margin: 0;
`;

export const HelperText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const HelperBullets = styled.ul`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  line-height: 1.8;
  list-style: none;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin: 0 0 24px 0;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '';
      width: 6px;
      height: 6px;
      background: #fa4616;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SortableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .sortable-ghost {
    opacity: 0.4;
  }

  .sortable-chosen {
    box-shadow: 0 4px 16px
      ${({ theme }) =>
        theme.name === 'dark' ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.12)'};
  }
`;

// Lap Sponsorship Card Wrapper
export const CardWrapper = styled.div`
  background: ${({ theme }) => (theme.name === 'dark' ? '#1e293b' : '#ffffff')};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  border-radius: 12px;
  transition: all 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: ${({ theme }) =>
      theme.name === 'dark' ? '#475569' : '#cbd5e1'};
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  gap: 16px;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 12px;
    flex-wrap: wrap;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  flex-shrink: 0;
  padding: 4px;
  margin: -4px;
  border-radius: 4px;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  }

  &:active {
    cursor: grabbing;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const CardTitle = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RaceName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const RaceNamePlaceholder = styled.span`
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  font-style: italic;
`;

// Summary badges container
export const SummaryBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    order: 10;
    flex-basis: 100%;
    margin-top: 8px;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'};
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  border: 1px solid
    ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)'};

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const PayoutCountBadge = styled(Badge)`
  background: ${({ theme, count }) =>
    count > 0
      ? theme.name === 'dark'
        ? 'rgba(34, 197, 94, 0.15)'
        : 'rgba(34, 197, 94, 0.1)'
      : theme.name === 'dark'
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(0,0,0,0.04)'};
  color: ${({ theme, count }) =>
    count > 0
      ? theme.name === 'dark'
        ? '#4ade80'
        : '#16a34a'
      : theme.name === 'dark'
      ? '#64748b'
      : '#94a3b8'};
  border-color: ${({ theme, count }) =>
    count > 0
      ? theme.name === 'dark'
        ? 'rgba(34, 197, 94, 0.3)'
        : 'rgba(34, 197, 94, 0.2)'
      : theme.name === 'dark'
      ? 'rgba(255,255,255,0.1)'
      : 'rgba(0,0,0,0.06)'};
`;

// Expand/collapse button
export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${({ theme, expanded }) =>
    expanded ? '#fa4616' : theme.name === 'dark' ? '#334155' : '#f1f5f9'};
  border: none;
  color: ${({ theme, expanded }) =>
    expanded ? '#ffffff' : theme.name === 'dark' ? '#94a3b8' : '#64748b'};
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme, expanded }) =>
      expanded ? '#e03d0d' : theme.name === 'dark' ? '#475569' : '#e2e8f0'};
    color: ${({ theme, expanded }) =>
      expanded ? '#ffffff' : theme.name === 'dark' ? '#ffffff' : '#0f172a'};
  }

  svg {
    transition: transform 0.2s ease;
    transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0)')};
  }
`;

// Delete button
export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(239, 68, 68, 0.1)'
      : 'rgba(239, 68, 68, 0.08)'};
  border: 1px solid
    ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.3)'
        : 'rgba(239, 68, 68, 0.2)'};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fca5a5' : '#dc2626')};
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.2)'
        : 'rgba(239, 68, 68, 0.15)'};
    border-color: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.5)'
        : 'rgba(239, 68, 68, 0.4)'};
  }
`;

// Actions container
export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

// Expandable content panel
export const ExpandedContent = styled.div`
  max-height: ${({ expanded }) => (expanded ? '1000px' : '0')};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  overflow: hidden;
  transition: all 0.3s ease;
`;

export const ContentInner = styled.div`
  padding: 0 20px 20px 20px;
  border-top: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  margin-top: -1px;
  padding-top: 20px;

  @media (max-width: 768px) {
    padding: 0 16px 16px 16px;
    padding-top: 16px;
  }
`;

// Form grid for main fields
export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Total payout display
export const TotalPayoutDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  margin: 20px 0 24px 0;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(16, 185, 129, 0.1))'
      : 'linear-gradient(135deg, rgba(34, 197, 94, 0.08), rgba(16, 185, 129, 0.05))'};
  border: 1px solid
    ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(34, 197, 94, 0.3)'
        : 'rgba(34, 197, 94, 0.2)'};
  border-radius: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const TotalPayoutLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};

  svg {
    color: ${({ theme }) => (theme.name === 'dark' ? '#4ade80' : '#16a34a')};
  }
`;

export const TotalPayoutValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => (theme.name === 'dark' ? '#4ade80' : '#16a34a')};

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const TotalPayoutCalculation = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin-left: 8px;
`;

// Section divider
export const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h4`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const SectionLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
`;

// Payout rules container
export const PayoutRulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// Individual payout rule card
export const PayoutRuleCard = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 16px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  border-radius: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PayoutRuleNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.1)'};
  color: #fa4616;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PayoutFieldsRow = styled.div`
  display: flex;
  gap: 12px;
  flex: 1;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PayoutField = styled.div`
  flex: ${({ flex }) => flex || 1};
`;

export const DeleteRuleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  margin-bottom: 6px;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.1)'
        : 'rgba(239, 68, 68, 0.08)'};
    border-color: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.3)'
        : 'rgba(239, 68, 68, 0.2)'};
    color: ${({ theme }) => (theme.name === 'dark' ? '#fca5a5' : '#dc2626')};
  }

  @media (max-width: 768px) {
    align-self: flex-end;
    margin-bottom: 0;
    margin-top: -8px;
  }
`;

// Add payout rule button wrapper
export const AddRuleButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 8px;
`;

// Allocation Summary Bar
export const AllocationSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-top: 16px;
  border-radius: 8px;
  background: ${({ theme, status }) => {
    if (status === 'over')
      return theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.15)'
        : 'rgba(239, 68, 68, 0.08)';
    if (status === 'exact')
      return theme.name === 'dark'
        ? 'rgba(34, 197, 94, 0.15)'
        : 'rgba(34, 197, 94, 0.08)';
    if (status === 'under')
      return theme.name === 'dark'
        ? 'rgba(59, 130, 246, 0.15)'
        : 'rgba(59, 130, 246, 0.08)';
    return theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.03)';
  }};
  border: 1px solid
    ${({ theme, status }) => {
      if (status === 'over')
        return theme.name === 'dark'
          ? 'rgba(239, 68, 68, 0.3)'
          : 'rgba(239, 68, 68, 0.2)';
      if (status === 'exact')
        return theme.name === 'dark'
          ? 'rgba(34, 197, 94, 0.3)'
          : 'rgba(34, 197, 94, 0.2)';
      if (status === 'under')
        return theme.name === 'dark'
          ? 'rgba(59, 130, 246, 0.3)'
          : 'rgba(59, 130, 246, 0.2)';
      return theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.06)';
    }};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const AllocationLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const AllocationText = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => (theme.name === 'dark' ? '#e2e8f0' : '#334155')};

  span {
    font-weight: 600;
  }
`;

export const AllocationProgress = styled.div`
  width: 200px;
  height: 6px;
  border-radius: 3px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'};
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AllocationProgressFill = styled.div`
  height: 100%;
  border-radius: 3px;
  width: ${({ percent }) => Math.min(percent, 100)}%;
  background: ${({ status }) => {
    if (status === 'over') return '#ef4444';
    if (status === 'exact') return '#22c55e';
    if (status === 'under') return '#3b82f6';
    return '#94a3b8';
  }};
  transition: width 0.3s ease, background 0.3s ease;
`;

export const AllocationStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ status }) => {
    if (status === 'over') return '#ef4444';
    if (status === 'exact') return '#22c55e';
    if (status === 'under') return '#3b82f6';
    return '#94a3b8';
  }};

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Empty state - Dashed border box style
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  border: 2px dashed
    ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.15)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 12px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.02)'
      : 'rgba(0, 0, 0, 0.01)'};
`;

export const EmptyIcon = styled.div`
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0 0 8px 0;
`;

export const EmptyDescription = styled.p`
  font-size: 13px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin: 0 0 20px 0;
  max-width: 400px;
`;

// Loading state
export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 16px;
`;

// Payout empty state (within card)
export const PayoutEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.02)'};
  border: 1px dashed
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  border-radius: 8px;
  text-align: center;
`;

export const PayoutEmptyText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin: 0 0 16px 0;
`;

// Button wrapper for controlled width
export const ButtonWrapper = styled.div`
  width: auto;
  display: inline-block;

  button {
    width: auto;
    padding: 10px 20px;
  }
`;

// Modal styled components for delete confirmation
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#334155' : '#e2e8f0')};
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#1e293b' : '#ffffff'};
`;

export const ModalHeaderTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#ffffff' : '#0f172a')};
  margin: 0;
`;

export const ModalCloseBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: ${({ theme }) =>
    theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgba(0, 0, 0, 0.05)'};
  color: ${({ theme }) => (theme?.name === 'dark' ? '#94a3b8' : '#64748b')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }) =>
      theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.15)'
        : 'rgba(0, 0, 0, 0.08)'};
    color: ${({ theme }) => (theme?.name === 'dark' ? '#ffffff' : '#0f172a')};
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#1e293b' : '#ffffff'};
`;

export const ModalText = styled.p`
  font-size: 15px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#cbd5e1' : '#475569')};
  margin: 0 0 24px 0;
  line-height: 1.6;
`;

export const ModalButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;
